module Meevo.Plugins.Register {
    "use strict";

    export class SpecifyTeacherSection extends Meevo.Plugins.Register.SpecifyEmployeeSection {

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(registerContext);
        }

        reset() {
            this.isTeacherSelection = true;
            this.getEmployees();
        }

        add(teacher) {
            this.registerContext.assignTeacherToServiceSaleLines(teacher);
            if ((device.mobile() || (device.tablet() && device.portrait() && !device.largeTablet()))) {
                //regular ipad in portrait - mobile navigation
                this.registerContext.selectSection(RegisterSectionTypeEnum.Ticket);
            } else {
                //device is not mobile or ipad portrait
                //normal navigation flow
                this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
            }
        }
    }


}